import { eponaQuery } from '@/helpers/graphql_modules/epona';
import { DisciplineInstance } from '@/models/pegasus-epona/discipline-instance.model';
import { getDisciplineInstanceQuery } from '@/store/queries/pegasus-epona.queries';

export class DisciplineInstanceService {
  static async getDisciplineInstance(
    courseId: string,
    disciplineId: String,
  ): Promise<DisciplineInstance> {
    const disciplineInstance = await eponaQuery(getDisciplineInstanceQuery, {
      courseId,
      disciplineId,
    });

    const {
      data: { getDisciplineLessons },
    } = disciplineInstance;

    return getDisciplineLessons.data;
  }
}
